module.exports = __webpack_public_path__ + "img/homepage2_04-asesoria-en-siniestros.f37513b1.jpg";